import { Button } from "@material-ui/core";
import React from "react";

export default function PaymentActions({ onClick }) {
    return (
        <div className="mx-auto py-10">
            <div className="row align-items-center justify-content-center w-100">
                {["Call", "Selected", "Confirm", "Hold", "Message", "Transfer", "Cancel"].map((item, idx) => {
                    return (
                        <div key={"action_" + idx} className="mx-2">
                            <Button onClick={() => onClick(item)} className="btn-app" data-color={item}>
                                {item}
                            </Button>
                        </div>
                    );
                })}
            </div>
        </div>
    );
}
